import DialogNewPass from './DialogNewPass';
export default DialogNewPass;
export { default as DialogNewPass } from './DialogNewPass';